import { getToken, getRefreshToken, getUserRef } from '../../../../services/services-jwt'

export default {
    token : getToken() || null,
    refresh : getRefreshToken() || null,
    userRef : getUserRef() || null,
    refreshToken : null,
}
